import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { NotificationManager } from 'react-notifications';

// Services
import productsService from "@services/products";

// Components
import ReactTable from '@components/ReactTable';

import POSPage from '@components/POSPage'
import paginator from '@utils/paginator'

import Custom from './Custom'

import { EventBus as eventBus } from "@components/EventBus";

class Page extends Component {
    constructor(props) {
        super(props);

        this.state = {
            table: {
                columns: [
                    {
                      Header: 'Produto',
                      accessor: 'idproduct',
                    },
                    {
                      Header: 'Designação',
                      accessor: 'name',
                    },
                    {
                      Header: 'Quantidade',
                      accessor: 'qtd',
                    },
                    {
                        Header: 'Contagem',
                        id: 'counter',
                        accessor: d => (
                            <Custom key={d.idproduct} id={d.idproduct} setCustomValue={this.setCustomQuantity} customValue={d.counter} />
                        ),
                    },
                    {
                      Header: 'Diferença',
                      id: 'diff',
                      accessor: d => d.qtd !==  '-' && d.counter !== '' ? d.counter - d.qtd : '-',
                    },
                ],
                rows: [],
                loading: true,
            },
            summary: {
                category: { name: '' },
            },
            pagination: {
                left: {
                    first: {
                        click: () => this.setState({ page: 1 }),
                        show: true,
                    },
                    previous: {
                        click: () => this.setState({ page: this.state.page - 1 }),
                        show: true,
                    }
                },
                right: {
                    next: {
                        click: () => this.setState({ page: this.state.page + 1 }),
                        show: true,
                    },
                    last: {
                        click: () => this.setState({ page: this.state.lastPage }),
                        show: true,
                    }
                }
            },
            items: [],
            page: 1,
            lastPage: 0,
            pageSize: 24,
            loaded: false,
            filters: [{
                label: 'Nome',
                field: 'name',
                value: '',
                placeholder: 'Pesquise pelo Nome',
                handleChange: (e) => this.handleChangeFilter(e),
            },{
                label: 'ID Produto',
                field: 'idproduct',
                value: '',
                placeholder: 'Pesquise pelo ID do produto',
                handleChange: (e) => this.handleChangeFilter(e),
            },{
                label: 'Código de Barras',
                field: 'barcode',
                value: '',
                placeholder: 'Pesquise pelo Código de Barras',
                handleChange: (e) => this.handleChangeFilter(e),
                handleFocus: (e) => {
                    this.setState({ filters: this.state.filters.map((filter) => {
                        return {
                            ...filter,
                            value: filter.field === 'barcode' ? '' : filter.value,
                        }
                    }) });
                },
                handleKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        this.playBarcodeSound();
                        e.target.blur();
                        requestAnimationFrame(() => {
                            setTimeout(() => {
                                const inputSelector = 'input[name="custom"]';
                                const counterInput = document.querySelector(inputSelector);
                                if (counterInput) {
                                    counterInput.focus();
                                }
                            }, 50);
                        });
                    }
                },
            }],
        };

        this.loadFunction = this.loadFunction.bind(this);
        this.setCustomQuantity = this.setCustomQuantity.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
        this.deleteCounter = this.deleteCounter.bind(this);
        
        // Inicializar som de código de barras
        this.barcodeSound = new Audio('/barcode.mp3');
    }
    
    // Método para tocar som de código de barras
    playBarcodeSound = () => {
        try {
            this.barcodeSound.currentTime = 0;
            this.barcodeSound.play().catch(err => console.log('Erro ao tocar som:', err));
        } catch (err) {
            console.log('Erro ao tocar som:', err);
        }
    }

    setCustomQuantity (quantity, id) {
        const newItems = this.state.table.rows.map((item) => {
            if (item.idproduct === id) {
                // Se quantity for string vazia, manter como string vazia
                // Se quantity for um número (incluindo 0), converter para número
                if (quantity === '' || quantity === null || quantity === undefined) {
                    return { ...item, counter: '' };
                } else {
                    const numValue = parseInt(quantity, 10);
                    return { ...item, counter: isNaN(numValue) ? '' : numValue };
                }
            }
            return item;
        });
        eventBus.$emit("SET/steps/form", { values: newItems });
        this.setState({ table: {
            ...this.state.table,
            rows: newItems
        } });
    }

    deleteCounter (id) {
        const newItems = this.state.table.rows.map((item) => {
            if (item.idproduct === id) {
                return { ...item, counter: '' };
            }
            return item;
        });
        eventBus.$emit("SET/steps/form", { values: newItems });
        this.setState({ table: {
            ...this.state.table,
            rows: newItems
        } });
    }

    async loadFunction() {
        if (!this.state.loaded) {
            try {
                const { form } = this.props;
                const idempresa = this.props.cookies.get('member_idempresa');
                const values = form.category.idcategoria === -1 ? await productsService.getPostoProducts(idempresa, form.warehouse.posto) : await productsService.getPostoProductsByFamilia(idempresa, form.category.idcategoria, form.warehouse.posto);

                const enrichedCustomers = values[form.warehouse.posto].items.map((value) => {
                    const specificValue = this.props.form.values.find((item) => 
                        value.idproduct === item.idproduct && 
                        (item.counter !== '' && item.counter !== null && item.counter !== undefined)
                    );
                    return {
                        ...value,
                        qtd: value.stock || '-',
                        counter: (specificValue || {}).counter !== undefined ? specificValue.counter : '',
                        barcode: value.barcodes.map(({ barcode }) => barcode).join(),
                    };
                });

                this.setState({ 
                    table: {
                        ...this.state.table,
                        rows: enrichedCustomers,
                        loading: false,
                    }, 
                    loaded: true 
                });
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                NotificationManager.error('Erro ao carregar produtos', 'Produtos');
            }
        }
    }

    handleChangeFilter(e) {
        this.setState({ filters: this.state.filters.map((filter) => {
            // Verificar se o campo corresponde (string ou array)
            const fieldMatches = Array.isArray(filter.field) 
                ? filter.field.includes(e.target.name)
                : filter.field === e.target.name;
            
            return {
                ...filter,
                value: fieldMatches ? e.target.value : filter.value,
            }
        }) });
    }

    handleChange(e, callback) {
        let value = e.target.value;
        let name = e.target.name;
        
        this.setState({
            [name]: value,
        });
    }

    getFilteredItems() {
        const { table, filters } = this.state;
        const { form } = this.props;

        // Verificar se há pesquisa ativa (se algum filtro tem valor)
        const hasActiveSearch = filters.some(filter => filter.value && filter.value.trim() !== '');

        // Aplicar filtros de pesquisa
        let filteredItems = table.rows.filter((item) => {
            return filters
                .every((filter) => {
                    if (!filter.value || filter.value.trim() === '') return true;
                    
                    // Se field é um array, verificar qualquer um dos campos
                    // Se field é uma string, verificar apenas esse campo
                    const fieldsToCheck = Array.isArray(filter.field) ? filter.field : [filter.field];
                    
                    const filterValues = filter.value.split(' ').filter(v => v.trim() !== '');
                    
                    return filterValues.every((filterValue) => {
                        const normalizedFilterValue = filterValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                        
                        // Verificar se o valor corresponde a qualquer um dos campos
                        return fieldsToCheck.some((field) => {
                            const itemValue = (item[field] || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                            return itemValue.includes(normalizedFilterValue);
                        });
                    });
                });
        });

        // Se idcategoria === -1 e não há pesquisa, ocultar produtos sem contagem
        // 0 é considerado como contagem válida, apenas strings vazias são desconsideradas
        if (form.category.idcategoria === -1 && !hasActiveSearch) {
            filteredItems = filteredItems.filter((item) => {
                return item.counter !== '' && item.counter !== null && item.counter !== undefined;
            });
        }

        // Se há pesquisa e idcategoria === -1, ordenar com produtos contados no topo
        // 0 é considerado como contagem válida, apenas strings vazias são desconsideradas
        if (form.category.idcategoria === -1 && hasActiveSearch) {
            filteredItems = filteredItems.sort((a, b) => {
                const aHasCounter = a.counter !== '' && a.counter !== null && a.counter !== undefined;
                const bHasCounter = b.counter !== '' && b.counter !== null && b.counter !== undefined;
                
                if (aHasCounter && !bHasCounter) return -1;
                if (!aHasCounter && bHasCounter) return 1;
                return 0;
            });
        }

        return filteredItems;
    }

    render () {
        const { items, pagination, page, pageSize, table, filters } = this.state;
        const { form } = this.props;
        
        const pageInfo = paginator(items, page, pageSize);

        const realPagination = {
            left: pageInfo.pre_page ? pagination.left : { first: {}, previous: {} },
            right: pageInfo.next_page ? pagination.right : { next: {}, last: {} },
        }

        // Obter itens filtrados usando a função auxiliar
        const filteredItems = this.getFilteredItems();

        // Definir colunas da tabela
        let columns = [...table.columns];
        
        // Adicionar coluna de apagar apenas quando idcategoria === -1
        if (form.category.idcategoria === -1) {
            columns.push({
                Header: 'Ações',
                id: 'actions',
                accessor: d => {
                    // Só mostrar o botão se a linha tiver contagem
                    const hasCounter = d.counter !== '' && d.counter !== null && d.counter !== undefined;
                    if (!hasCounter) return null;
                    
                    return (
                        <button
                            onClick={() => this.deleteCounter(d.idproduct)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#dc3545',
                                padding: '5px 10px',
                                fontSize: '16px'
                            }}
                            title="Apagar contagem"
                        >
                            <i className="fas fa-trash-alt" />
                        </button>
                    );
                },
                excel: false,
            });
        }

        return (
            <POSPage
                pagination={ realPagination }
                filters={ filters }
                loadFunction={ this.loadFunction }
            >
                <ReactTable
                    columns={ columns }
                    sortable={ true }
                    loading={ table.loading }
                    data={ filteredItems }
                    defaultPageSize={ 20 }
                    noDataText={ form.category.idcategoria === -1 ? 'Os resultados serão exibidos após a contagem' : 'Sem resultados' }
                />
            </POSPage>
        );
    }
}

export default withCookies(Page);